<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#e8e8e8" type = "ball-pulse" [fullScreen] = "true"><p style="color: #e8e8e8" > Please wait ... </p></ngx-spinner>
